module.exports = __webpack_public_path__ + "static/img/success_bg.470093c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register/success_bg.png
// module id = H8GR
// module chunks = 1